import { render } from "./searchApi.vue?vue&type=template&id=b08b60a8"
import script from "./searchApi.vue?vue&type=script&lang=js"
export * from "./searchApi.vue?vue&type=script&lang=js"

import "./searchApi.vue?vue&type=style&index=0&id=b08b60a8&lang=css"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__